<template>
    <div>
        <v-card>
            <v-container>
                <v-form ref="form" v-model="valid">
                    <v-row class="mt-8">
                        <v-col cols="12" sm="1" md="1"></v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-icon
                                class="grey--text ma-3 pa-3 mx-auto my-auto"
                                size="120"
                                elevation-8
                            >
                                mdi-office-building-marker
                            </v-icon>
                            <v-card-text
                                class="grey--text display-1 font-weight-black"
                            >
                                Novo Cartório
                            </v-card-text>
                            <v-card-text class="grey--text font-weight-black">
                                Preencha os dados abaixo para cadastrar um novo
                                cartório no sistema.
                            </v-card-text>
                        </v-col>
                        <v-col cols="12" sm="6" md="8">
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-card-text
                                        class="grey--text font-weight-light"
                                    >
                                        Código IBGE *
                                    </v-card-text>
                                    <v-text-field
                                        prepend-icon="mdi-sticker-text"
                                        name="CodIbge"
                                        label="Código IBGE do cartório"
                                        type="text"
                                        :rules="requiredRules"
                                        solo
                                        v-model="cartorio.cd_ibge_comarca"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-card-text
                                        class="grey--text font-weight-light"
                                    >
                                        Número do Cartório *
                                    </v-card-text>
                                    <v-text-field
                                        prepend-icon="mdi-sticker-text"
                                        name="numero"
                                        label="Número do Cartório"
                                        type="text"
                                        :rules="requiredRules"
                                        solo
                                        v-model="cartorio.nu_cartorio"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="11">
                                    <v-card-text
                                        class="grey--text font-weight-light"
                                    >
                                        Nome do Cartório *
                                    </v-card-text>
                                    <v-text-field
                                        prepend-icon="mdi-sticker-text"
                                        name="NomeCartório"
                                        label="Nome do Cartório"
                                        type="text"
                                        :rules="requiredRules"
                                        solo
                                        v-model="cartorio.nm_cartorio"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-card-text
                                        class="grey--text font-weight-light"
                                    >
                                        Telefone *
                                    </v-card-text>
                                    <v-text-field
                                        prepend-icon="mdi-sticker-text"
                                        name="telefone"
                                        label="Telefone do Cartório"
                                        :rules="requiredRules"
                                        solo
                                        v-model="cartorio.telefone"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="7">
                                    <v-card-text
                                        class="grey--text font-weight-light"
                                    >
                                        E-mail *
                                    </v-card-text>
                                    <v-text-field
                                        name="EmailCartorio"
                                        label="E-mail do Cartório"
                                        :rules="[rules.required, rules.email]"
                                        solo
                                        v-model="cartorio.email"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-card-text
                                        class="grey--text font-weight-light"
                                    >
                                        CNPJ *
                                    </v-card-text>
                                    <v-text-field
                                        name="cnpj"
                                        label="CNPJ do Cartório"
                                        :rules="[
                                            rules.required,
                                            rules.validarCNPJ
                                        ]"
                                        v-mask="'XX.XXX.XXX/XXXX-##'"
                                        solo
                                        v-model="cartorio.cnpj"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-card-text
                                        class="grey--text font-weight-light"
                                    >
                                        CEP *
                                    </v-card-text>
                                    <v-text-field
                                        prepend-icon="mdi-sticker-text"
                                        name="cep"
                                        label="CEP do Cartório"
                                        :rules="requiredRules"
                                        solo
                                        v-model="cartorio.cep"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-card-text
                                        class="grey--text font-weight-light"
                                    >
                                        Endereço *
                                    </v-card-text>
                                    <v-text-field
                                        name="endereco"
                                        label="Endereço do Cartório"
                                        :rules="requiredRules"
                                        solo
                                        v-model="cartorio.endereco"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-card-text
                                        class="grey--text font-weight-light"
                                    >
                                        Número *
                                    </v-card-text>
                                    <v-text-field
                                        name="numero"
                                        label="Número"
                                        :rules="requiredRules"
                                        solo
                                        v-model="cartorio.endereco_numero"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="5">
                                    <v-card-text
                                        class="grey--text font-weight-light"
                                    >
                                        Complemento
                                    </v-card-text>
                                    <v-text-field
                                        prepend-icon="mdi-sticker-text"
                                        name="complemento"
                                        label="Complemento"
                                        solo
                                        v-model="cartorio.complemento"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-card-text
                                        class="grey--text font-weight-light"
                                    >
                                        Bairro *
                                    </v-card-text>
                                    <v-text-field
                                        name="bairro"
                                        label="Bairro do Cartório"
                                        :rules="requiredRules"
                                        solo
                                        v-model="cartorio.bairro"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-card-text
                                        class="grey--text font-weight-light"
                                    >
                                        Cidade *
                                    </v-card-text>
                                    <v-text-field
                                        name="cidade"
                                        label="Cidade do Cartório"
                                        :rules="requiredRules"
                                        solo
                                        v-model="cartorio.nm_cidade"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-card-text
                                        class="grey--text font-weight-light"
                                    >
                                        Estado *
                                    </v-card-text>
                                    <v-select
                                        name="estado"
                                        label="Estado do Cartório"
                                        :rules="requiredRules"
                                        :items="listaUfs"
                                        solo
                                        v-model="cartorio.cd_uf"
                                        required
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-card-text
                                        class="grey--text font-weight-light"
                                    >
                                        Responsável pelo Tabelionato
                                    </v-card-text>
                                    <v-text-field
                                        name="responsavel"
                                        label="Responsável do Cartório"
                                        solo
                                        v-model="
                                            cartorio.nm_responsavel_tabelionato
                                        "
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card>
    </div>
</template>

<script>
import { validarCNPJ } from '../helpers/Utilitarios';

export default {
    name: 'CriarCartorio',
    props: {
        validarForm: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            cartorio: {
                cd_ibge_comarca: '',
                nu_cartorio: '',
                nm_cartorio: '',
                cnpj: '',
                cep: '',
                endereco: '',
                endereco_numero: '',
                complemento: '',
                bairro: '',
                nm_cidade: '',
                cd_uf: '',
                nm_responsavel_tabelionato: '',
                telefone: '',
                email: ''
            },
            valid: false,
            rules: {
                required: value => !!value || 'Campo obrigatório',
                validarCNPJ: value => {
                    if (!value) return true;
                    const stripped = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
                    if (stripped.length !== 14) return 'CNPJ inválido';
                    if (!/^[A-Z0-9]{12}\d{2}$/.test(stripped)) return 'CNPJ inválido';
                    return true;
                },
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || 'E-mail inválido';
                }
            },
            requiredRules: [v => !!v || 'Campo Obrigatório'],
            listaUfs: [
                'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO',
                'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
                'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
            ]
        };
    },
    methods: {
        validarCNPJ,
        getCartorio() {
            return { ...this.cartorio };
        },
        resetForm() {
            this.$refs.form.reset();
        }
    },
    watch: {
        'cartorio.cnpj'(val) {
            if (val) {
                const upper = val.toUpperCase();
                if (upper !== val) this.cartorio.cnpj = upper;
            }
        },
        validarForm(val) {
            if (val) {
                this.$refs.form.validate();
                this.$emit('formValidado', false);
            }
        },
        valid(val) {
            this.$emit('setIsInvalid', !val);
        }
    }
};
</script>

<style scoped></style>
